import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import EbookCard from '../components/catalog/EbookCard';
import api from '../utils/api';

export default function SellerProfilePage() {
  const { userId } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/api/profile/${userId}`)
      .then(r => setProfile(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [userId]);

  if (loading) return <div className="flex items-center justify-center h-screen text-gray-400">Memuat...</div>;
  if (!profile) return <div className="flex items-center justify-center h-screen text-gray-400">Profil tidak ditemukan</div>;

  const { user, tenant, ebooks } = profile;
  const initials = user.name?.slice(0,2).toUpperCase() || '??';
  const joined = new Date(user.created_at).toLocaleDateString('id-ID', {month:'long', year:'numeric'});

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6 flex items-center gap-5">
          <div className="w-16 h-16 rounded-full bg-wa-dark flex items-center justify-center text-white text-xl font-bold flex-shrink-0">{initials}</div>
          <div>
            <h1 className="text-xl font-bold text-gray-800">{user.name}</h1>
            {tenant && <p className="text-wa-dark font-medium text-sm">{tenant.name}</p>}
            {tenant?.description && <p className="text-gray-500 text-sm mt-0.5">{tenant.description}</p>}
            <p className="text-gray-400 text-xs mt-1">Bergabung {joined}</p>
          </div>
        </div>

        {/* Ebooks */}
        <h2 className="font-semibold text-gray-700 mb-3">Ebook ({ebooks.length})</h2>
        {ebooks.length === 0
          ? <p className="text-gray-400 text-sm">Belum ada ebook.</p>
          : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {ebooks.map(e => (
                <div key={e.id} onClick={() => navigate(`/?ebook=${e.id}`)} className="cursor-pointer">
                  <EbookCard ebook={e} />
                </div>
              ))}
            </div>
        }
      </div>
    </div>
  );
}
